module.exports = __webpack_public_path__ + "img/forex-trading-2.2ef72d84.png";